<template>
  <div class="header" id="home-header">
    <div class="header-content">
      <div class="header-logo">
        <img :src="static_img_url+'pic/logo-vcbeat.png?v='+ $store.state.version" @click="returnIndex">
      </div>
      <div class="header-navigation">
        <Poptip trigger="hover" @on-popper-show="handlePoptip('APP')">
          <div slot="content" class="code-list">
            <div class="code-item">
              <img :src="static_img_url + 'pic/download-code-pcheader.png'" />
              <p>扫码下载</p>
            </div>
          </div>
          <div class="nav-item">APP</div>
        </Poptip>
        <div :class="['nav-item']" @click="handleChangeRoute('LinkIndex', 1)">
          <!-- <img class="icon-img" :src="$store.state.static_img_url + 'pic/hot.png'" /> -->
          <!-- <span>{{linkPageType == 1 ? '产业链接' : '供需对接'}}</span> -->
          <span>产业链接</span>
        </div>
        <Poptip trigger="hover" @on-popper-show="handlePoptip('公众号矩阵')">
          <div slot="content" class="code-list">
            <div class="code-item">
              <img :src="static_img_url + 'pic/vcbeat/ft_ewm_2.jpg'" />
              <p>动脉网</p>
            </div>
            <div class="code-item">
              <img :src="static_img_url + 'pic/vcbeat/xinyiyao.jpg'" />
              <p>动脉新医药</p>
            </div>
            <div class="code-item">
              <img :src="static_img_url + 'pic/vcbeat/chengguoju.jpg'" />
              <p>动脉橙果局</p>
            </div>
            <div class="code-item">
              <img :src="static_img_url + 'pic/vcbeat/link-code.png'" />
              <p>产业链接</p>
            </div>
            <div class="code-item">
              <img :src="static_img_url + 'pic/vcbeat/chanyezhiku.png'" />
              <p>动脉橙产业智库</p>
            </div>
          </div>
          <div class="nav-item">公众号矩阵</div>
        </Poptip>
        <!-- <div :class="['nav-item', $route.name == 'VBResearch' && 'on']" @click="handleChangeRoute('VBResearch', 1)">蛋壳研究院</div> -->
        <!-- <div :class="['nav-item']" @click="handleChangeRoute('searchTrack', 1)">动脉橙产业智库</div> -->
        <!-- <div :class="['nav-item']" @click="handleChangeRoute('VBEF', 1)">VBEF</div> -->
        <div :class="['nav-item', 'on']" @click="handleClickProExperience">
          <!-- <img class="icon-img" :src="$store.state.static_img_url + 'pic/new30.png?v=2'"/> -->
          <span>动脉智库</span>
        </div>
        <Dropdown placement="bottom-start" @on-visible-change="handleChangeActivity" @on-click="handleChangeRoute($event, 1)">
          <div class="nav-item" :class="[activity_visible && 'visible']" @click="handleChangeRoute('ActivityList', 1)">
            <span>活动会议</span>
            <Icon type="ios-arrow-down"></Icon>
          </div>
          <DropdownMenu slot="list">
            <DropdownItem name="activity1">2025数字疗法大会</DropdownItem>
            <DropdownItem name="activity2">CSGCT第二届中国细胞与基因治疗大会</DropdownItem>
            <DropdownItem name="activity3">2025VBEF未来医疗100强展会</DropdownItem>
            <DropdownItem name="activity4">2025VBEF直播回放&百强榜单</DropdownItem>
            <DropdownItem name="ActivityList">全部活动</DropdownItem>
          </DropdownMenu>
        </Dropdown>
        <div :class="['nav-item', $route.name == 'IndustrialSolutions' && 'on']" @click="handleChangeRoute('IndustrialSolutions', 1)">解决方案</div>
        <div :class="['nav-item']" @click="handleChangeRoute('动脉AI', 1)">动脉AI</div>
      </div>
      <!-- <img :src="static_img_url + 'pic/ai-nav.png'" class="vbef-img-btn" @click="handleChangeRoute('AI', 1)" /> -->
      <div class="header-search">
        <Input prefix="ios-search" placeholder="输入相关搜索词" v-model="searchWord" @on-enter="handleClickSearch" />
        <!-- <div class="btn" @click="handleClickAISearch">
          <span class="spa1">AI</span>
          <span>搜索</span>
        </div> -->
        <div class="btn" @click="handleClickSearch">
          <span>搜索</span>
        </div>
      </div>
      <div class="en-btn" @click="handleChangeRoute('EN', 1)">EN</div>
      <div class="header-user">
        <span v-if="!user_key" @click="showLogin" onclick="_czc.push(['_trackEvent', '顶部菜单(新)', '登录', '点击量'])">登录</span>
        <Dropdown v-else @on-click="clickDropDown" trigger="hover" placement="bottom-end" :transfer="true" transfer-class-name="usernavlist">
          <img :src="wx_image" v-if="wx_image" />
          <img :src="static_img_url+'pic/default_header.png'" v-else />
          <DropdownMenu slot="list">
            <DropdownItem name="collect"><i class="iconfont-sm">&#xe66e;</i><span>我的收藏</span></DropdownItem>
            <DropdownItem name="order"><i class="iconfont-sm">&#xe614;</i><span>订单管理</span></DropdownItem>
            <DropdownItem name="my_product"><i class="iconfont-sm">&#xe623;</i><span>已购产品</span></DropdownItem>
            <DropdownItem name="account"><i class="iconfont-sm">&#xe61e;</i><span>账号设置</span></DropdownItem>
            <DropdownItem name="quit"><i class="iconfont-sm">&#xe620;</i><span>退出</span></DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </div>
    </div>
    <!-- <Login :loginModal="loginModal" @logincancel="loginCancel"></Login> -->
    <LoginNew ref="login-new"></LoginNew>
    <!-- <SearchModal :searchModal="search_modal" @searchcancel="searchCancel"></SearchModal> -->

  </div>
</template>

<script>
import SearchModal from './SearchModal.vue'
import LoginNew from './LoginNew.vue'
import { mapState } from 'vuex'
import { loginOut } from '../service'
import Cookies from 'js-cookie'
export default {
  inject: ['haddleApplyTry2', 'reload', 'globalInsertRecords', 'handleClickProExperience'],

  components: {
    LoginNew,
    SearchModal,
  },
  data() {
    return {
      activity_visible: false,
      loginModal: false,
      search_modal: false,
      active_name: '',
    }
  },
  computed: {
    ...mapState({
      user_key: (state) => state.user_key,
      user: (state) => state.user,
      static_img_url: (state) => state.static_img_url,
      index_path: (state) => state.index_path,
      index2_path: (state) => state.index2_path,
      vbef_path: (state) => state.vbef_path,
      uUid: (state) => state.uUid,
    }),
    wx_image() {
      return this.$store.state.user.wx_avatarurl || this.$store.state.user.wxAvatarurl || ''
    },
    isShowNavigation() {
      const router_arr = ['Index', 'IntelDetail', 'IntelAuthor', 'LinkDetail']
      return router_arr.indexOf(this.$route.name) > -1
    },
    linkPageType() {
      let str = this.uUid || ''
      // 使用正则表达式匹配首个数字
      const match = str.match(/\d/)
      // 如果找到了数字
      if (match) {
        // 将数字字符串转换为数值
        const number = parseInt(match[0], 10)
        // 判断数字是还是偶数
        if (number % 2 === 0) {
          return 2 //偶数
        } else {
          return 1 //奇数
        }
      } else {
        // 如果没有找到数字，则返回相应信息
        return 1
      }
    },
  },
  methods: {
    handleChangeRoute(name, new_open = 0) {
      let href,
        href_str = ''
      switch (name) {
        case 'VBEF':
          href_str = '未来医疗生态展会'
          href = 'https://www.vbdata.cn/home/channelDetail/192'
          break
        case 'activity1':
          href_str = '2025数字疗法大会'
          href = 'https://dtc.vbdata.cn/'
          break
        case 'activity2':
          href_str = 'CSGCT第二届中国细胞与基因治疗大会'
          href = 'https://www.csgct.com.cn/?language=zh'
          break
        case 'activity3':
          href_str = '2025VBEF未来医疗100强展会'
          href = 'http://vbef.vbdata.cn/'
          break
        case 'activity4':
          href_str = '2025VBEF直播回放&百强榜单'
          href = 'https://www.vbdata.cn/home/channelDetail/192'
          break
        case 'LinkIndex':
          // href_str = this.linkPageType == 1 ? '产业链接' : '供需对接'
          href_str = '产业链接'
          href = this.index2_path + '/home/linkIndex'
          break
        case 'VBResearch':
          href_str = '蛋壳研究院'
          href = this.index2_path + '/VBResearch'
          break
        case 'IndustrialSolutions':
          href_str = '解决方案'
          href = this.index2_path + '/IndustrialSolutions'
          break
        case 'searchTrack':
          href_str = '动脉橙产业智库'
          href = this.index_path + '/searchTrack'
          break
        case 'VB100':
          href_str = 'VB100官网'
          href = 'https://vb100.vbdata.cn/'
          break
        case 'VB100List':
          href_str = 'VB100榜单'
          href = 'https://vb100.vbdata.cn/list/'
          break
        case 'ActivityList':
          href_str = '活动会议'
          href = this.index2_path + '/home/activityList'
          break
        case '动脉AI':
          href_str = '动脉AI'
          href = 'https://ai.vbdata.cn/'
          break
        case 'EN':
          href_str = 'EN'
          href = 'https://www.vcbeatglobal.com/'
          break
      }
      this.globalInsertRecords({
        content_type: 72,
        enter_type: 23,
        view_type: 1,
        keyword: href_str,
      })
      if (new_open) window.open(href, '_blank')
      else window.location.href = href
    },
    handleChangeActivity(value) {
      this.activity_visible = value
      if (value) {
        this.globalInsertRecords({
          content_type: 72,
          enter_type: 23,
          view_type: 2,
          keyword: '活动会议',
        })
      }
    },
    handlePoptip(value) {
      this.globalInsertRecords({
        content_type: 72,
        enter_type: 23,
        view_type: 2,
        keyword: value,
      })
    },
    clearModal2BodyStyle() {
      document.body.style.paddingRight = ''
      document.body.style.overflow = ''
    },
    showLogin(cb = null) {
      // this.loginModal = !this.loginModal
      this.$refs['login-new'].modelIndex = true
      this.$refs['login-new'].loginCallBack = cb
    },
    loginCancel(value) {
      this.loginModal = value
      if (!value) {
        this.clearModal2BodyStyle()
      }
    },
    // searchCancel(value) {
    //   this.search_modal = value
    //   if (!value) {
    //     this.clearModal2BodyStyle()
    //   }
    // },
    returnIndex() {
      const href = this.index2_path
      window.location.href = href
    },
    async clickDropDown(name) {
      if (name == 'quit') {
        // 退出
        let res = await loginOut({ user_key: this.user_key }, (error) => {
          this.$Message.error('请求错误！')
        })
        if (res.status == 'success') {
          this.$Message.success('退出成功！')
          this.$store.commit('updateUser', '')
          this.$store.commit('updateUserKey', '')
          this.$store.commit('updateFilter', '')
          this.$store.commit('topicEntityCount', '')
          this.$store.commit('topicTagCount', '')
          this.$store.commit('updateIdentity', true)
          this.$store.commit('setUUserId', null)
          this.$store.commit('updateTiaojian', '')
          window.localStorage.removeItem('show_scientific')

          Cookies.remove('user_key_' + this.$store.state.cookie_type, {
            domain: this.$store.state.domain_path,
            path: '/',
          })

          this.reload()
        } else {
          this.$Message.error(res.message)
        }
      }
      if (name == 'coupon') {
        // 优惠券
        // this.$router.push({ name: 'UserCoupon' })
        let link = this.index_path + '/userCoupon'
        window.open(link)
      }
      if (name == 'order') {
        // 我的订单
        // this.$router.push({ name: 'OrderList' })
        let link = this.index_path + '/orderList'
        window.open(link)
      }
      if (name == 'my_product') {
        // 我的报告
        // this.$router.push({ name: 'UserProduct' })
        let link = this.index_path + '/userProduct'
        window.open(link)
      }
      if (name == 'account') {
        // 账号设置
        // this.$router.push({ name: 'UserAccount' })
        let link = this.index2_path + '/home/userAccount'
        window.open(link)
      }
      if (name == 'collect') {
        // 收藏
        // this.$router.push({ name: 'Collect' })
        let link = this.index2_path + '/collect'
        window.open(link)
      }
    },
    handleClickSearch() {
      // this.search_modal = !this.search_modal
      this.globalInsertRecords({
        content_id: 13,
        content_type: 17,
        enter_type: this.enter_type,
        view_type: 1,
        keyword: this.searchWord,
      })
      const encodedKeyword = encodeURIComponent(this.searchWord)
      const href = this.index2_path + '/home/search?keyword=' + encodedKeyword
      window.open(href, '_blank')
      _czc.push(['_trackEvent', '顶部菜单(新)', '搜索', '点击量'])
    },
    handleClickAISearch() {
      this.globalInsertRecords({
        content_type: 72,
        enter_type: this.enter_type,
        view_type: 1,
        keyword: 'AI搜索',
      })
      const encodedKeyword = encodeURIComponent(this.searchWord)
      const href = this.index2_path + '/home/search?type=99&keyword=' + encodedKeyword
      window.open(href, '_blank')
    },
    activeName(name) {
      // 点击menuitem
      if (name == 'org-apply') {
        this.haddleApplyTry2(11)
      }
      if (name == 'data-src') {
        _czc.push(['_trackEvent', '顶部菜单(新)', '数据产品(动脉橙LOGO)', '点击量'])
        let link = this.index_path + '/searchTrack'
        window.open(link)
      }
    },
  },
  created() {},
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
.header-content
  width 1200px
  height 64px
  margin 0 auto
  display flex
  align-items center
  .header-logo
    flex 0 0 121px
    max-width 121px
    min-width 121px
    font-size 0
    display flex
    align-items center
    img
      width 121px
      height 30px
      cursor pointer
  .header-navigation
    flex auto
    margin-left 30px
    display flex
    align-items center
    font-size 14px
    > div
      &+div
        margin-left 26px
    .nav-item
      color #333333
      cursor pointer
      display flex
      align-items center
      justify-content center
      transition all 0.3s
      font-size 16px
      position relative
      span
        &+i
          transition all 0.3s
          margin-left 4px
      .icon-img
        position absolute
        width 25px
        height 14px
        right -24px
        top -7px
        z-index 2
      &.visible
        color #FA5A00
        i
          transform rotate(180deg)
      &:hover, &.on
        color #FA5A00
      &.disabled
        color #999999
        cursor not-allowed
        &:hover
          color #999999
    >>> .ivu-poptip
      .ivu-poptip-arrow
        display none
      .ivu-poptip-popper
        min-width auto
        padding 20px 0 7px 0
      .ivu-poptip-inner
        background-color none
        border-radius 0
        .ivu-poptip-body
          padding 0
    >>> .ivu-dropdown
      .ivu-select-dropdown
        padding 20px 0 5px
        margin 0
        border-radius 0
        box-shadow none
        background none
        .ivu-dropdown-menu
          box-shadow 0 1px 6px rgba(0, 0, 0, 0.2)
          background-color #fff
          padding 5px 0
          .ivu-dropdown-item
            color #333333
    .code-list
      display flex
      padding 20px 10px 10px
      background #F5F7F9
      .code-item
        display flex
        flex-direction column
        align-items center
        width 100px
        img
          width 80px
          height 80px
        p
          margin-top 7px
          font-size 12px
          font-weight 400
          color #333333
          line-height 17px
        & + div
          margin-left 10px
  .header-user
    display flex
    justify-content center
    align-items center
    span
      display inline-block
      line-height 24px
      color #fff
      font-size 14px
      cursor pointer
      background-color #FA5A00
      width 60px
      max-width 60px
      min-width 60px
      text-align center
      line-height 32px
      &:hover
        background-color #FF4800
    .default-header
      color #333333
      font-size 30px
      cursor pointer
    img
      width 30px
      height 30px
      max-width 30px
      min-width 30px
      border-radius 50%
      cursor pointer
  .en-btn
    cursor pointer
    color #FA5A00
    font-size 16px
    margin-right 15px
    &:hover
      color #FF4800
  .header-search
    margin-right 15px
    display flex
    align-items center
    position relative
    >>> .ivu-input-wrapper
      .ivu-input-with-prefix
        padding 0 76px 0 32px
      .ivu-input
        width 230px
        height 40px
        background #FFFFFF
        border-radius 6px
        border 1px solid #EEEEEE
        box-shadow none
      .ivu-input-prefix
        width 32px
        i
          line-height 38px
          font-size 20px
          color #000000
    .btn
      position absolute
      right 10px
      top 10px
      display flex
      align-items center
      justify-content center
      cursor pointer
      // background linear-gradient(132deg, #B721FF 0%, #21D4FD 100%)
      border-radius 6px
      span
        font-size 14px
        color #FA5A00
        line-height 20px
        &.spa1
          font-weight 600
.iconfont-sm
  inlineBlock()
  margin-right 12px
  font-size 18px
  color #999999
  vertical-align middle
.vbef-img-btn
  max-width 110px
  min-width 110px
  height auto
  cursor pointer
  margin-right 10px
  border-radius 6px
</style>
